import { ContentCopy as ContentCopyIcon } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';

interface CopyableTextProps {
  text: string;
  copyLabel: string;
  onCopy: () => void;
}

const CopyableText = ({ text, copyLabel, onCopy }: CopyableTextProps) => (
  <div className='relative rounded-md bg-gray-50'>
    <Tooltip title={copyLabel}>
      <IconButton
        size='small'
        aria-label={copyLabel}
        className='!absolute right-1 top-1'
        onClick={onCopy}
      >
        <ContentCopyIcon fontSize='small' />
      </IconButton>
    </Tooltip>
    <pre className='whitespace-pre-wrap p-3 pr-10 text-xs text-gray-800'>{text}</pre>
  </div>
);

export default CopyableText;
